module.exports = __webpack_public_path__ + "static/media/office-1920.80ed08e3.jpg";